// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__t0M8l","productName":"Table_productName__2NJ_1"};